import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/25.jpg";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";

export const PersonMikryakov = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}>Микряков Андрей Денисович</MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Bachelor of Industrial Automation, Master student of Computer Science and Engineering
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={12} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://orcid.org/0009-0004-3827-5832'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>ТОО «Astana IT University», разработчик встраиваемых систем, НИЦ «Industry 4.0». <b>Стаж — 2 года.</b></MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте</MyText>
                <MyText size={"small"} italic>Младший научный сотрудник</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка встраиваемых систем и IoT-устройств;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Интеграция датчиков и модулей связи (LoRa, GSM, Wi-Fi);
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Тестирование и запуск метеостанций в полевых условиях.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Студент магистратуры по «Computer Science and Engineering». Опыт в встраиваемых системах, прототипировании, беспроводной связи, микроконтроллерах, облачной архитектуре и 3D-моделировании.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR21882258 «Экологический мониторинг эмиссий» (2023-2025) — исполнитель.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR24993128 «ИАС трансграничных водных ресурсов» (2024-2026) — исполнитель.
                </MyText>
            </Flex>
        </Flex>
    );
};
